import { Routes, Route } from 'react-router-dom';
import { Article, CareGuideDetails, Contact, Error } from 'pages';
import VideoPage from 'pages/Video';

function Router() {
  return (
    <Routes>
      <Route path="care/:care_id">
        <Route index element={<CareGuideDetails />} />
        <Route path="article/:article_id" element={<Article />} />
        <Route path="video/:video_id" element={<VideoPage />} />
      </Route>
      <Route path="error" element={<Error />} />
      <Route path="contact" element={<Contact />} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
}

export default Router;
